module.exports = __webpack_public_path__ + "media/images/countrysquared/ir-f140809b45f1bd60ea8cc6c187bd144c.svg";